import React from 'react'
import { useTheme } from '../hooks/useTheme';
import { formatUSPhone, getUSPhoneDigits } from '../../utils/phoneFormatter';

type PhoneNumberInputProps = {
    name: string;
    value: string;
    setValue: (value: string) => void;
    fontSize?: string;
    paddingBlock?: string;
    required?: boolean;
    readOnly?: boolean;
    disabeld?: boolean;
    tabIndex?: number
}

const PhoneNumberInput = ({
    name,
    value,
    setValue,
    fontSize = "12px",
    paddingBlock,
    required = false,
    readOnly,
    disabeld,
    tabIndex
}: PhoneNumberInputProps) => {
    const { themeStyles } = useTheme();

    return (
        <input
            type="text"
            tabIndex={tabIndex}
            readOnly={readOnly}
            disabled={disabeld}
            pattern="\(\d{3}\) \d{3}-\d{4}"
            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
            title="Please enter a 10-digit phone number."
            name={name}
            value={formatUSPhone(value)}
            onChange={(e) => {
                const digits = getUSPhoneDigits(e.target.value);
                setValue(digits);
            }}
            required={required}
        />
    );
};

export default PhoneNumberInput;